import { createContext, ReactNode, useContext, useState } from "react";
import { TDevice } from "../types/Devices";

type DeviceSettingsContextValues = {
  selectedDevice: TDevice;
  setSelectedDevice: (device: TDevice) => void;
  isDeviceModalOpen: boolean;
  onOpenDeviceModal: (device: TDevice) => void;
  onCloseDeviceModal: () => void;
};

export const DeviceSettingsContext = createContext(
  {} as DeviceSettingsContextValues
);

export const useDeviceSettingsContext = () => useContext(DeviceSettingsContext);

export const DeviceSettingsContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  // const { setNotification } = useNotificationContext();

  const [selectedDevice, setSelectedDevice] = useState({} as TDevice);
  const [isDeviceModalOpen, setIsDeviceModalOpen] = useState(false);

  const onOpenDeviceModal = (device: TDevice) => {
    setSelectedDevice(device);
    setIsDeviceModalOpen(true);
  };

  const onCloseDeviceModal = () => {
    setSelectedDevice({} as TDevice);
    setIsDeviceModalOpen(false);
  };

  return (
    <DeviceSettingsContext.Provider
      value={{
        selectedDevice,
        setSelectedDevice,
        isDeviceModalOpen,
        onOpenDeviceModal,
        onCloseDeviceModal,
      }}
    >
      {children}
    </DeviceSettingsContext.Provider>
  );
};
